import { Grid, Hidden } from '@mui/material';
import React from 'react';
import ControlledInputText from 'components/common/forms/controlled_input_text';
import ControlledCheckbox from 'components/common/forms/controlled_checkbox';
import { useTranslation } from 'react-i18next';
import { buildLegalLink } from 'utilities/links';
import { useFormContext } from 'react-hook-form';
import {
  BIRTHDATE_REGEX,
  POSTAL_CODE_REGEX_BY_COUNTRY,
  EXPERIAN_PATTERNS,
} from 'constants/patterns';

const Fields = (props) => {
  const { applicationData, disabled } = props;
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.firstName')}
          name="personal_first_name"
          control={control}
          rules={{
            required: true,
          }}
          disabled
          defaultValue={applicationData.personal_first_name || ''}
          autocomplete="given-name"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.lastName')}
          name="personal_last_name"
          control={control}
          rules={{
            required: true,
          }}
          disabled
          defaultValue={applicationData.personal_last_name || ''}
          autocomplete="family-name"
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <ControlledInputText
          label={t('checkout.label.dateOfBirth')}
          name="personal_birthdate"
          control={control}
          disabled={disabled}
          rules={{
            required: true,
            pattern: BIRTHDATE_REGEX,
          }}
          defaultValue={applicationData.personal_birthdate || ''}
          placeholder="AAAA-MM-DD"
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <ControlledInputText
          label={t('checkout.label.addressLine1')}
          name="personal_street_1"
          control={control}
          disabled={disabled}
          rules={{
            required: true,
            pattern: EXPERIAN_PATTERNS.street,
          }}
          defaultValue={applicationData.personal_street_1 || ''}
          autocomplete="address-line1"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label={t('checkout.label.addressLine2')}
          name="personal_street_2"
          defaultValue={applicationData.personal_street_2 || ''}
          control={control}
          rules={{
            pattern: EXPERIAN_PATTERNS.street,
          }}
          disabled={disabled}
          autocomplete="address-line2"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.city')}
          name="personal_city"
          defaultValue={applicationData.personal_city || ''}
          control={control}
          disabled={disabled}
          rules={{
            required: true,
            pattern: EXPERIAN_PATTERNS.city,
          }}
          autocomplete="address-level2"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.postalCode')}
          name="personal_postal_code"
          disabled={disabled}
          defaultValue={applicationData.personal_postal_code || ''}
          control={control}
          maxlength={5}
          rules={{
            required: true,
            maxLength: 5,
            pattern: POSTAL_CODE_REGEX_BY_COUNTRY.ES,
          }}
          autocomplete="postal-code"
        />
      </Grid>
      {/* Hidden field to send personal_state_province to capital-shop if present else empty string*/}
      <Hidden implementation="css" xsUp>
        <Grid item xs={12} md={4}>
          <ControlledInputText
            label={t('checkout.label.state')}
            name="personal_state_province"
            disabled
            defaultValue={applicationData.personal_state_province || ''}
            control={control}
          />
        </Grid>
      </Hidden>
      <Grid item xs={12} md={12} mb={2}>
        <ControlledCheckbox
          name="accepted_legal_agreements"
          control={control}
          disabled={disabled}
          label={
            <div
              dangerouslySetInnerHTML={{
                __html: t('checkout.financeApp.legal_agreement_html', {
                  privacyLink: buildLegalLink('/privacy'),
                  esignLink: buildLegalLink('/sign'),
                  generalLink: buildLegalLink('/ua'),
                }),
              }}
            />
          }
          defaultValue={applicationData.accepted_legal_agreements || false}
          rules={{ required: true }}
        />
      </Grid>
    </>
  );
};

export default Fields;
